import React, { useEffect, useState } from "react";
import { Consent, readConsent, writeConsent, onOpenCookieSettings } from "../lib/consent";
import { startAnalytics, stopAnalytics } from "../firebase/firebaseApp";

// Analytics runs unless the visitor rejects, or waits for Accept in the EU (see _app.js).
// The strip shows until they choose, and again from the footer's Cookies link.
const CookieBanner = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (readConsent() === null) setOpen(true);
    return onOpenCookieSettings(() => setOpen(true));
  }, []);

  const choose = (value: Consent) => {
    writeConsent(value);
    if (value === "granted") startAnalytics();
    else stopAnalytics();
    setOpen(false);
  };

  if (!open) return null;

  return (
    <section
      aria-label="Cookie preferences"
      className="fixed bottom-4 left-4 right-4 sm:right-auto z-[60] flex flex-wrap items-center justify-between gap-x-6 gap-y-2 bg-white/80 backdrop-blur-md border border-zinc-200 px-4 py-3"
    >
      {/* Balanced wrap keeps three or more words per line if a phone splits it. */}
      <p className="font-sans text-[13px] leading-snug text-zinc-600 sm:whitespace-nowrap" style={{ textWrap: "balance" }}>
        We use cookies for a better experience.
      </p>
      <div className="flex gap-4">
        <button type="button" onClick={() => choose("denied")} className="font-mono text-[11px] text-zinc-400 hover:text-black transition-colors uppercase">
          Reject
        </button>
        <button type="button" onClick={() => choose("granted")} className="font-mono text-[11px] text-[#2F54EB] hover:text-black transition-colors uppercase">
          Accept
        </button>
      </div>
    </section>
  );
};

export default CookieBanner;
